module.exports = __webpack_public_path__ + "static/media/awards_4.c822de38.jpg";